export const CASHIER = {
  cash: 'cash',
  card: 'card',
};

export default {
  CASHIER,
};
